import { FC } from 'react'
import PageLayout from '../../components/page-layout/page-layout'
import TableWrapper from '../../components/table-wrapper/table-wrapper'
import { Table, TableProps } from 'antd'
import { useGetTubesQuery } from '../../store/api/tubes-api'
import useTablePagination from '../../hooks/table-pages/use-table-pagination'
import useEndpointQueryParams, {
    DeserializeFilters,
} from '../../hooks/table-pages/use-endpoint-query-parameters'
import qs from 'qs'
import FiltersForm from './components/filters-form/filters-form'
import { columns } from './constants/columns '
import FormValues from './components/filters-form/types/form-values'
import { EndpointQueryParameters, Filters } from '../../types/strapi/strapi'
import getBetweenByOneDate from '../../helpers/filters/get-between-by-one-date'
import Tube from '../../types/api/tube'
import EditableRow from './components/table/editable/editable-row'
import EditableCell from './components/table/editable/editable-cell'
import './index.css'
import { useHasRole } from '../../hooks/use-has-role'
import { BusinessRole } from '../../types/api/user'

const deserializeFilters: DeserializeFilters = filtersString => {
    const formValues = qs.parse(filtersString) as Partial<FormValues>
    const { name, externalId, endDate, roller, shape, materialGroups } =
        formValues

    const filters: Filters = {
        number: { $contains: name },

        stamps: {
            externalId: { $contains: externalId },
            roller: { documentId: { $eq: roller } },
            shape: { $in: shape },
            material_groups: { documentId: { $in: materialGroups } },
        },
    }
    /* 
    if (createdAt) filters.createdAt = getBetweenByOneDate(createdAt)
    if (estimatedDate) filters.estimatedDate = getBetweenByOneDate(estimatedDate) */
    if (endDate) {
        filters.stamps = {
            ...filters.stamps,
            last_order: { endDate: getBetweenByOneDate(endDate) },
        }
    }
    return filters
}

type ColumnTypes = Exclude<TableProps<Tube>['columns'], undefined>

interface StampMainPageProps {}

const StampMainPage: FC<StampMainPageProps> = () => {
    const params = useEndpointQueryParams({ deserializeFilters })
    const isSuperAdmin = useHasRole(BusinessRole.SuperAdmin)
    const isCurator = useHasRole(BusinessRole.Curator)
    const readOnly = isCurator && !isSuperAdmin

    const tubesQueryParams: EndpointQueryParameters = {
        populate: {
            stamps: {
                populate: {
                    contractor: true,
                    last_order: { populate: { initiator: true } },
                    material_groups: true,
                    roller: true,
                    image: true,
                },
            },
        },
        filters: params.filters,
        pagination: params.pagination,
        sort: ['number:desc'],
    }
    const { data, isLoading } = useGetTubesQuery(tubesQueryParams)

    const pagination = useTablePagination(params, data)
    const dataSource: Tube[] = data?.data || []
    const components = readOnly
        ? undefined
        : {
              body: {
                  row: EditableRow,
                  cell: EditableCell,
              },
          }

    const mapColumns = (col: any) => {
        if (readOnly && col.title === 'Действия') {
            return {
                ...col,
                render: () => null,
            }
        }
        if (!col.editable || readOnly) {
            return { ...col, editable: false }
        }
        const newCol = {
            ...col,
            onCell: (record: any) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                editableCellType: col.editableCellType,
                tubesQueryParams: tubesQueryParams,
            }),
        }
        if (col.children) {
            newCol.children = col.children.map(mapColumns)
        }
        return newCol
    }

    const columnsData = columns.map(x => mapColumns(x))
    return (
        <PageLayout title={'Штампы'}>
            <TableWrapper currentTableHeight={110} style={{ flex: 'auto' }}>
                <Table
                    bordered
                    columns={columnsData as ColumnTypes}
                    rowKey={'documentId'}
                    rowClassName={() => 'editable-row'}
                    components={components}
                    dataSource={dataSource}
                    pagination={pagination}
                    loading={isLoading}
                    scroll={{ x: 2600 }}
                    summary={() => (
                        <Table.Summary fixed={'top'}>
                            <FiltersForm />
                        </Table.Summary>
                    )}
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default StampMainPage
